import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { enableList, startUsing } from "@/api/management/user";
export default {
  props: {
    enable: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tableLoading: false,
      loading: false,
      name: "",
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      specialUserId: ""
    };
  },
  created: function created() {
    this.getTabledata();
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit("close");
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.specialUserId = selection[0].specialUserId;
      }

      if (selection.length > 1) {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(selection.pop());
      }
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getTabledata();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getTabledata();
    },
    getTabledata: function () {
      var _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$enableList, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tableLoading = true;
                params = {
                  current: this.pageNum,
                  size: this.pageSize,
                  name: this.name
                };
                _context.next = 4;
                return enableList(params);

              case 4:
                _yield$enableList = _context.sent;
                data = _yield$enableList.data;
                this.tableLoading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.msg);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTabledata() {
        return _getTabledata.apply(this, arguments);
      }

      return getTabledata;
    }(),
    search: function search() {
      this.pageNum = 1;
      this.getTabledata();
    },
    toenable: function () {
      var _toenable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$startUsing, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.specialUserId == "" || this.specialUserId == null || this.specialUserId == undefined)) {
                  _context2.next = 3;
                  break;
                }

                this.$message.error("请选择用户");
                return _context2.abrupt("return");

              case 3:
                params = {
                  userId: this.enable.userId,
                  specialUserId: this.specialUserId
                };
                this.loading = true;
                _context2.next = 7;
                return startUsing(params);

              case 7:
                _yield$startUsing = _context2.sent;
                data = _yield$startUsing.data;
                this.loading = false;

                if (data.code == 0) {
                  this.$message.success("启用成功");
                  this.$emit("close", true);
                } else {
                  this.$message.error(data.msg);
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function toenable() {
        return _toenable.apply(this, arguments);
      }

      return toenable;
    }()
  },
  computed: {
    tableItem: function tableItem() {
      return this.enable.tableItem;
    }
  },
  watch: {
    "enable.state": function enableState(newval) {
      var _this = this;

      if (newval) {
        this.$nextTick(function () {
          _this.$refs.table.clearSelection();

          _this.specialUserId = "";
          _this.name = "";
        });
      }
    }
  }
};